import './login.css';

import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import React from 'react';

import { SingleSignOnLogin } from '../../components/auth/single-sign-on-login';
import { Checkbox } from '../../components/ui/checkbox';
import { InputText } from '../../components/ui/input-text/input-text';
import { ForgotPasswordModal } from './forgot-password-modal';
import { useLogin } from './use-login';

export const Login = () => {
  const { values, errors, loading, onSubmit, onChange, onToggleRememberMe, navigateRegister } = useLogin();

  return (
    <>
      <Card title="Login">
        <SingleSignOnLogin />
        <Divider align="center">
          <span>or Sign in with Email</span>
        </Divider>
        <InputText name="email" placeholder="Email" error={errors.email} onChange={onChange} iconLeft="pi-user" />
        <InputText
          name="password"
          placeholder="Password"
          error={errors.password}
          onChange={onChange}
          iconLeft="pi-hashtag"
          password={true}
          toggleMask
          feedback={false}
        />
        <div className="flex justify-content-between">
          <Checkbox label="Remember me" name="remember-me" checked={values.rememberMe} onChange={onToggleRememberMe} />
          <div className="field">
            <ForgotPasswordModal />
          </div>
        </div>
        <div className="p-fluid flex">
          <Button label="Login" className="p-button-rounded" onClick={onSubmit} loading={loading} disabled={loading} />
        </div>
      </Card>
      <div
        className="p-4"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span className="mr-2">New here?</span>
        <Button label="Sign up instead" onClick={navigateRegister} className="p-button-outlined ml-2" />
      </div>
    </>
  );
};
